const constants = {
  HOME_PAGE: 'Home',
  HOME_PAGE_ROUTE: '/',
  SIGNUP_PAGE: 'Sign up',
  SIGNUP_PAGE_ROUTE: '/sign-up',
  LOGIN_PAGE: 'Login',
  LOGIN_PAGE_ROUTE: '/login',
  CONTACT_PAGE: 'Contact us',
  CONTACT_PAGE_ROUTE: '/contact-us',
  CONNECTIONS_PAGE: 'Connections',
  CONNECTIONS_PAGE_ROUTE: '/connections',
  CHAT_PAGE: 'Chat',
  CHAT_PAGE_ROUTE: '/chats',
  NOTIFICATIONS_PAGE: 'Notifications',
  NOTIFICATIONS_PAGE_ROUTE: '/notifications',
  PROFILE_PAGE: 'Profile',
  PROFILE_PAGE_ROUTE: '/profile',
  WEBSITE_NAME: 'ALPHA-OMEGA',
  WELCOME_MSG_I:
    'Welcome to ALPHA-OMEGA, your one stop solution to get admits from top universities around the world.',
  WELCOME_MSG_II:
    'How does it work ? \n We help you connect with students in your dream universities so that you can learn how they did it and you can do it too. You can view their profile, SOP and connect with them for some handy tips and tricks.',
  COPYRIGHT_MSG_I: 'Copyright 2020, Alpha Omega Private Limited.',
  COPYRIGHT_MSG_II: ' All Rights Reserved.',
  SIGNUP_DATA: {
    alpha: [
      { id: 1, msg: 'Looking forward to up your education game' },
      {
        id: 2,
        msg:
          'Want to score good at standardised tests like SAT, GRE, TOEFL etc.',
      },
      {
        id: 3,
        msg:
          'Want to get started with shortlisting universities, creating SOPs and LORs.',
      },
      {
        id: 4,
        msg:
          'Willing to help others when you get your admit and transition into an omega.',
      },
    ],
    omega: [
      { id: 1, msg: 'You are a professor or a student in a university.' },
      {
        id: 2,
        msg: 'Looking forward to help students with their doubts and queries.',
      },
      { id: 3, msg: 'Willing to share your winning SOPs, LORs etc.' },
      { id: 4, msg: 'Earn reward points to redeem for amazing incentives.' },
    ],
  },
  USER_TYPE_ALPHA: 'alpha',
  USER_TYPE_OMEGA: 'omega',
  ADMITTED_UNIVERSITIES: 'Admitted Universities',
  LETTER_OF_RECOMMENDATIONS: 'Letter of Recommendations',
  STATEMENT_OF_PURPOSE: 'Statement of Purpose',
  PENDING_REQUESTS: 'Pending Requests',
  RECENTYLY_ADDED: 'Recently added',
};

export default constants;
